#import ".../../../../../../common/graphql/TagEntityFields.graphql"

mutation TagCreate($input: TagCreateInput!) {
  tagCreate(input: $input) {
    tag {
      ...TagEntityFields
    }
  }
}
